import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusCompleteIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2.14-5.45a.4.4 0 0 0-.6-.56L5.37 6.84l-.92-.92a.4.4 0 1 0-.58.57L5.1 7.72a.4.4 0 0 0 .59-.01l2.45-2.66Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default StatusCompleteIcon;
